import React from 'react';
import { MainElement } from './style';

const PublicRouteLayout: React.FC = ({ children }) => {
    return (
        <MainElement>
            {children}
        </MainElement>
    );
};

export default PublicRouteLayout;
